import { getCurrentUser, getCookie } from './utils';

export async function getBestandImports(user_cases) {

  const response = await fetch('/import_bestand/findImportBestandByCases', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_cases }),
  });
  if (response.ok) return response.json();
  return [];
}

export async function createBestandImport({ entiteit, year, jrnid, accid }) {
  const factviewRefresh = getCookie('factview_refresh');
  const response = await fetch('/import_bestand/create', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ entiteit, year, jrnid, accid, factviewRefresh }),
  });
  if (!response.ok) throw new Error('Aanmaken mislukt');
  return response.json();
}

export async function deleteBestandImport(id) {
  await fetch(`/import_bestand/delete?id=${id}`);
}

export async function updateBestandImportStamp(id) {
  await fetch(`/import_bestand/updateStamp?id=${id}`);
}

export async function handleBestandImport({ entiteit, year, jrnid, accid, fileName, xmlContent }) {
  const user_id = await getCurrentUser();
  const response = await fetch('/bestand/handleImport', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ entiteit, year, jrnid, accid, fileName, xmlContent, user_id, office: '' }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `Import mislukt (${response.status})`);
  }
  return response.json();
}

export async function getBestandFiles(configId) {
  const user_id = await getCurrentUser();
  console.log(user_id);
  const response = await fetch(`/bestand/files?configId=${configId}&user_id=${user_id}`);
  if (response.ok) return response.json();
  return [];
}

export async function handleBestandFinal(entries) {
  const user_id = await getCurrentUser();
  const response = await fetch('/bestand/handleFinal', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ entries, user_id }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `handleFinal mislukt (${response.status})`);
  }
  return response.json();
}

export async function fetchBestandStatus() {
  const response = await fetch('/bestand/fetchUpdates');
  if (response.ok) return response.json();
  return [];
}

export async function resetBestandStatus() {
  await fetch('/bestand/resetStatus');
}

export async function deleteBankBestandById(case_id, factviewAccess, bankbestand_id) {
  const response = await fetch('https://api2.factview.nl/api/' + case_id + '/deleteBankBestandById', {
    method: 'POST',
    headers: {
      'authorization': 'Bearer ' + factviewAccess,
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({ bankbestand_id }),
  });
  if (response.ok) {
    const responseData = await response.json();
    console.log(responseData);
    return responseData;
  }
}
